import { render } from "./lnfhrz.vue?vue&type=template&id=fec21070&scoped=true&ts=true"
import script from "./lnfhrz.vue?vue&type=script&lang=ts"
export * from "./lnfhrz.vue?vue&type=script&lang=ts"

import "./lnfhrz.vue?vue&type=style&index=0&id=fec21070&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fec21070"]])

export default __exports__